export const FIXED_COLUMN_BEFORE_SIDE = 'left';
export const FIXED_COLUMN_AFTER_SIDE = 'right';
export const TABLE_FIXED_TYPE = 'fixed';
